function Start() {

    this.name = 'start';
}

export {Start};
